import React from 'react';
import SelectableList from '../common/selectable_list';
import Selectable from '../common/selectable';

const ParticipantGroupList = React.createClass({

	render: function() {

		let groups = this.props.items.map((group, i) => this._renderGroup(group, i));
	  return (
	  	<div className="abl-teachers-list">
	  		{groups}
			</div>
	  );
	},

	_renderGroup: function(group, i) {
		let key = 'group_' + i;
		return (
			<div key={key}>
				<Selectable 
					id={group.id}
					ref={group.id}
					data={group}
					selected={group.selected}
					onChange={this.props.onSelectAll}
					selectedClass="abl-selected">
				 <h4><a>{group.name}</a></h4>
				</Selectable>
				<SelectableList
	        tagName="ul"
	        selectedClass="abl-selected"
	        items={group.items}
	        itemTemplate={this._listItemTemplate}
	        onChange={this.props.onChange}
	        multiSelect={true} />
      </div>
		);
	},

	_listItemTemplate: function(item, handleClick) {
		return (
			<li onClick={handleClick}>
				<a>
					<span>{item.name}</span>
				</a>
			</li>
		);
	}

});

export default ParticipantGroupList;


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/participant_group_list.js
 **/